// extracted by mini-css-extract-plugin
export default {"badge":"CountDownTeaser_badge_WoCN_","separator":"CountDownTeaser_separator_zyAcN"};